export default __webpack_public_path__ + "static/media/water-165219_960_720.e1460254.jpg";